import { useEffect, useContext, useState } from "react";
import { Link, useParams, useNavigate,useLocation } from "react-router-dom";
import DisplayRecordsCard from "../DisplayRecordsCard";
import React from "react";
import { DataContext } from "../../providers/DataProvider";
import { DataHandlerContext } from "../../providers/DataHandlerProvider";
import DeleteModal from "../modal/DeleteModal";
import TopTitle from "../buttons/TopTitle";
import BackButton from "../buttons/BackButton";
import ModifyFormButton from "../buttons/ModifyFormButton";
import ShowDisabledMenu from "../navbar/ShowDisabledMenu";
import StatisticsButton from "../buttons/StatisticsButton";

function EventSeries({}) {
  const {
    eventSeriesData,
    eachEventSerieData,
    setEachEventSerieData,
    handlePopulateEventSeries,
    handlePopulateEachEventSeries,
    eachMarkForm,
    loading,
    error,
    totalAttendees,
    listOfUserSubmissions,
    setListOfUserSubmissions,
    setEventSeriesData,
    markFormObject,
  } = useContext(DataContext);

  const { handleDeleteEventSeries } = useContext(DataHandlerContext);

  const { eventseriesid } = useParams();
  const navigate = useNavigate();

  const [showDeleteEventSeriesModal, setShowDeleteEventSeriesModal] =
    useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const handleDeleteEventSerieData = (value, id) => {
    setShowDeleteEventSeriesModal(value);
    setDeletingId(id);
  };
  const location = useLocation();
  

  const deleteEventSerie = async (confirmDelete) => {
    setShowDeleteEventSeriesModal(false);
    if (confirmDelete) {
      try {
        const response = await handleDeleteEventSeries(deletingId);
        if (response.status === 200) {
          console.log("Event Series Deleted");
          setEventSeriesData((prevState) =>
            prevState.filter((event) => event.id !== deletingId)
          );
          navigate(-1);
        }
      } catch (error) {
        console.log("Error:", error);
      }
    }
  };

  useEffect(() => {

    console.log("Event Series ID inside EventSeries:", eventseriesid);

    if(location.pathname.includes("show-disabled-events")){
      handlePopulateEachEventSeries(eventseriesid,false,true);
    }else{
      handlePopulateEachEventSeries(eventseriesid,true,false);
    }
  
    
    console.log("eachEventSerieDataInside:", eachEventSerieData);
    console.log("MarkFormObject:", eachMarkForm);
  }, [eventseriesid, handlePopulateEachEventSeries,location.pathname]);

  
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className="flex flex-col min-h-screen bg-neutral-100">
      <div className="flex flex-col md:flex-row md:justify-between lg:px-[10rem] p-[2rem] py-10 md:py-20 gap-6 md:gap-0">
        <div>
          <BackButton 
            newLocation={`/home`}
          />
        </div>
      

        <div className="flex flex-col md:flex-row gap-4">
        <StatisticsButton 
        formData={eachEventSerieData}
        />

          <button
            className="px-4 py-2 bg-slate-700 text-white rounded-lg text-lg hover:shadow-lg flex gap-1 items-center justify-center w-full sm:w-auto"
            onClick={
              () =>  navigate(`/${eachEventSerieData.title?.toLowerCase().replace(/\s+/g, "-")}/events-series/${eachEventSerieData.id}/view`, { replace: true })}
          >
            <svg
              className="w-6 h-6 md:w-8 md:h-8"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 100 100"
            >
              <path d="m92.105 47.961c-10.535-13.711-24.426-21.535-39.355-22.426-1.5625-0.16406-3.918-0.16797-5.5 0-14.93 0.89453-28.82 8.7148-39.355 22.43-1 1.2852-1 3.0703 0 4.3555 10.535 13.57 24.465 21.285 39.395 22.145 1.3477 0.14844 3.6523 0.19141 5.4648 0 14.93-0.85547 28.82-8.5703 39.355-22.145 0.99609-1.2852 0.99609-3.0703-0.003906-4.3594zm-42.105 19.5c-9.6445 0-17.465-7.8203-17.465-17.465 0-9.6445 7.8203-17.465 17.465-17.465s17.465 7.8203 17.465 17.465c0 9.6445-7.8203 17.465-17.465 17.465z" />
              <path d="m55.82 55.785c-3.3555 3.1445-8.3203 3.1445-11.645 0-1.8203-1.9297-2.6055-4.3945-2.2852-6.7852 0.75 0.5 1.6445 0.75 2.6055 0.75 2.8555 0 5.1445-2.3203 5.1445-5.1445 0-0.96484-0.28516-1.8945-0.75-2.6445 2.4648-0.28516 5.1055 0.42969 6.9297 2.2148 3.1445 3.3242 3.1445 8.2852 0 11.609z" />
            </svg>
            <span>Form</span>
          </button>
          <button
            className="px-4 py-2 bg-yellow-400 text-white rounded-lg text-lg hover:shadow-lg flex gap-1 items-center justify-center w-full sm:w-auto"
            onClick={() =>  navigate(`/${eachEventSerieData.title?.toLowerCase().replace(/\s+/g, "-")}/events-series/${eachEventSerieData.id}/edit`, { replace: true })}
        

          >
            <svg
              version="1.1"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="w-5 h-5 md:w-6 md:h-6"
            >
              <g>
                <path d="m91.668 24.594-16.262-16.262-11.266 11.27 16.258 16.258z" />
                <path d="m25 75 17.887-1.625 30.777-30.781-16.258-16.258-30.781 30.777z" />
                <path
                  d="m62.5 91.668h-54.168v-8.3359h54.168z"
                  fillRule="evenodd"
                />
              </g>
            </svg>
            <span>Edit</span>
          </button>

          <button
            onClick={(e) => handleDeleteEventSerieData(true, eventseriesid)}
            className="rounded-lg text-lg hover:shadow-lg px-4 py-2 bg-red-300 text-red-700 flex gap-1 items-center justify-center w-full sm:w-auto"
          >
            <svg
              className="h-5   md:h-6 md:w-6"
              viewBox="0 0 100 100"
              fill="currentColor"
            >
              <path d="m50.094 8c-3.7031 0-6.4258 1.4609-8.2812 2.875s-3.0039 2.5742-4.9375 3.3438c-0.84766 0.27734-1.5547 0.94922-1.875 1.7812h-18v6h66v-6h-18c-0.32031-0.83203-1.0273-1.5078-1.875-1.7812-1.9531-0.77734-3.168-1.9453-5-3.3438s-4.4766-2.875-8.0312-2.875zm0 6c2.207 0.125 3.4531 0.93359 4.8438 2h-9.9375c1.7539-1.3516 3.5898-1.9844 5.0938-2zm-30.094 10v56.031c0 3.4922 0.91016 6.6406 3.125 8.8438s5.3867 3.125 8.9062 3.125h36c3.4844 0 6.6445-0.92188 8.8438-3.125s3.125-5.3516 3.125-8.8438v-56.031h-60z" />
            </svg>
            <span>Delete</span>
          </button>

          <Link to={`/${eachEventSerieData.title?.toLowerCase().replace(/\s+/g, "-")}/events-series/${eachEventSerieData.id}/add`}  className="w-full sm:w-auto">
            <button className=" p-4 py-2 px-6 border bg-green-700 w-full   ">
              <svg
                className="h-6 w-6 md:h-8 md:w-8"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              <span>Add Event</span>
            </button>
          </Link>
          <ModifyFormButton 
          eachEventSerieData={eachEventSerieData}
          type="event"
          />
        </div>
      </div>

      
      <div className="flex pt-0 justify-between lg:px-[10rem] p-[2rem] items-center md:space-x-4">
      
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold break-words">
          {eachEventSerieData.title} 
        </h1>      <ShowDisabledMenu/>

      </div>

      {showDeleteEventSeriesModal && (
        <DeleteModal
          text={"Are you sure you want to delete this event series?"}
          funct={deleteEventSerie}
        />
      )}

      <div className="flex flex-col md:flex-col justify-between px-4 lg:px-[10rem] items-center md:gap-4">
      {eachEventSerieData.events && eachEventSerieData.events.length > 0 ? (
  eachEventSerieData.events
    .sort((a, b) => {
      if (a.show_on_form !== b.show_on_form) {
        return a.show_on_form ? -1 : 1;
      }
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateA - dateB;
    })
    .map((event, key) => (
      <DisplayRecordsCard
        key={event.id}
        type="event"
        eventId={event.id}
        event_title={event.event_title}
        eventDate={event.date}
        googleCalendarId={event.google_calendar_id}
        maximumParticipants={event.maximumParticipants}
        notes={event.notes}
        targetParticipants={event.targetParticipants}
        totalAttendees={listOfUserSubmissions[event.id]?.length}
        listOfUserSubmissions={listOfUserSubmissions[event.id]}
        eventSeriesId={eachEventSerieData.id}
        setListOfUserSubmissions={setListOfUserSubmissions}
        allEvents={eachEventSerieData.events}
        setAllEvents={setEachEventSerieData}
        show_on_form={event.show_on_form}
        eachEventSerieData={eachEventSerieData}
      />
    ))
) : (
  <div className="text-center text-gray-500 mt-4 w-full p-8 bg-gray-100 ">
    No events available
  </div>
)}
        
      </div>
    </div>
  );
}

export default EventSeries;
